import { InsertQrRefundRequest } from "../requests/InsertQrRefundRequest";
import {axiosApiInstance} from "./HttpService";


export class MconboardingService{
    public static async insertQrRefund(request: InsertQrRefundRequest) {
        const dataURL: string = `${process.env.REACT_APP_API_URL}/api/QrViewer/insertQrRefund`;
        return await axiosApiInstance.post(dataURL, request);        
    }
}